import { Inject, Injectable } from '@angular/core';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import * as io from 'socket.io-client';
import { SDKConfig } from '../config/sdk-config.interface';
import { SDK_CONFIG_TOKEN } from '../config/sdk.config.token';
import { Message } from '../message';
import { UserRole, UserService } from '../user';
import { MessageState, MessageStore } from './message.store';

interface SocketUser {
  email: string;
  role: UserRole;
  id: string;
}

@Injectable()
export class MessageService extends NgEntityService<MessageState> {
  socket!: any;
  authorizedUser?: SocketUser;

  constructor(
    protected store: MessageStore,
    protected userService: UserService,
    @Inject(SDK_CONFIG_TOKEN) private sdkConfig: SDKConfig
  ) {
    super(store);
  }

  getUserMessages() {
    return this.getHttp()
      .get<Message[]>(`${this.sdkConfig.gatewayUrl}/messages`)
      .subscribe((messages) => {
        this.store.upsertMany(messages);
      });
  }

  getGroupMessages(groupId: string) {
    this.getHttp()
      .get<Message[]>(`${this.sdkConfig.gatewayUrl}/messages`, { params: { groupId } })
      .subscribe((messages) => {
        this.store.upsertMany(messages);
      });
  }

  sendMessage(text: any, groupId: string) {
    // this.chateor.sendSimpleMessage({ roomId, text });
    this.socket.emit('@message/create', {
      groupId,
      parts: [{ type: 'text', message: text }],
    });
  }

  init(token: string) {
    this.getUserMessages();
    this.socket = io(this.sdkConfig.messagesUrl, {
      transports: ['websocket'],
    });
    this.socket.on('connect', () => {
      this.socket.emit('authenticate', { token });
      this.socket.on('authenticated', (user: SocketUser) => {
        if (user) {
          this.authorizedUser = user;
          this.joinGroups();
          this.subscribeToNewMessages();
        }
      });
    });
  }

  subscribeToNewMessages() {
    this.socket.on('newMessage', (message: Message) => {
      this.socket.emit('@message/confirmReceived', message.id);
      this.store.add(message);
    });
  }

  joinGroups() {
    this.socket.emit('@message/joinGroups');
  }

  readMessage(messageId: string) {
    if (!this.authorizedUser) {
      return;
    }

    this.store.update(
      messageId,
      (message) =>
        ({
          ...message,
          usersRead: [...message.usersRead, this.authorizedUser?.id],
        } as any)
    );
    this.socket.emit('@message/confirmRead', messageId);
  }

  joinGroup(groupId: string) {
    this.socket.emit('@message/joinGroup', groupId);
  }

  unsubscribe() {
    this.socket.disconnect();
  }
}
